import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { CalendarEvent } from "../_types/calendar-event";
import { CalendarEventType } from "../_types/calendar-event-type";

@Injectable({
    providedIn: 'root',
})

export class CalendarsEventsTypesService extends Service<CalendarEventType> {
  public override type = 'calendarsEventsTypes';
  public override url = 'providers/calendarEventTypes';     
}
